export default {
  install(Vue) {
    // 全局指令 v-wechat-title="'页面标题'"
    Vue.directive('wechat-title', {
      inserted(el, binding) {
        if (binding && binding.value) {
          window.document.title = binding.value
        } else {
          window.document.title = ' '
        }
      },
      update(el, binding, vnode) {
        vnode.context.$route.meta.isCustomTitle = 1
        if (binding && binding.value) {
          window.document.title = binding.value
        }
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/assets/common/plugins/vue-wechat-title.js